import { ApiErrorCode } from '@orn/global/errors/apiErrorCodes.js';

import type { GraphQLFormattedError } from 'graphql';

export function extractErrorCode(errors: readonly GraphQLFormattedError[]): ApiErrorCode {
  const code = errors[0]?.extensions?.code;

  if (typeof code === 'string' && Object.values(ApiErrorCode).includes(code as ApiErrorCode)) {
    return code as ApiErrorCode;
  }

  return ApiErrorCode.INTERNAL_SERVER_ERROR;
}
